import React, { useEffect, useState } from "react";

const SEOChecklist = () => {
  const [tasks, setTasks] = useState([]);

  const checklist = [
    {
      section: "Get the homepage ready for Google Search",
      items: [
        "Set the homepage's title for search results",
        "Add the homepage's description for search results",
        "Add text to the homepage",
        "Allow indexing to make your homepage visible in search results",
        "Optimize the site for mobile devices",
        "Connect site to a custom domain",
        "Connect site to Google Search Consoles",
      ],
    },
    {
      section: "Optimize the site pages for search engines",
      items: [
        "Add alt text to all images on the homepage",
        "Add links to the homepage button",
        "Set the Security and Privacy page's title for search results",
        "Add the Security and Privacy pages meta description for search results",
        "Add alt text to all images on the Security and Privacy page",
        "Add links to the Security and Privacy page",
      ],
    },
    {
      section: "Technical SEO Tasks",
      items: [
        "Continuous Site SEO improvements",
        "Sitemaps",
        "Website Speed",
        "Semantic HTML",
        "Structured Data Schema",
        "Meta Description Management",
        "Google indexing",
      ],
    },
  ];

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("seo_checklist")) || {};
    setTasks(saved);
  }, []);

  const handleToggle = (section, item) => {
    const newTasks = { ...tasks };
    const key = `${section}::${item}`;
    newTasks[key] = !newTasks[key];
    setTasks(newTasks);
    localStorage.setItem("seo_checklist", JSON.stringify(newTasks));
  };

  return (
    <div className="mt-12 bg-neutral-900 border border-neutral-800 rounded-xl shadow p-6">
      <h3 className="text-lg font-semibold text-white mb-4">✅ SEO Optimization Checklist</h3>
      <div className="space-y-6">
        {checklist.map((group, idx) => (
          <div key={idx}>
            <h4 className="text-white font-medium mb-2">{group.section}</h4>
            <ul className="space-y-2">
              {group.items.map((item, i) => {
                const key = `${group.section}::${item}`;
                return (
                  <li
                    key={i}
                    className="flex items-center justify-between bg-neutral-800 p-3 rounded-md border border-neutral-700"
                  >
                    <span className={`text-sm ${tasks[key] ? "line-through text-green-400" : "text-white"}`}>
                      {item}
                    </span>
                    <input
                      type="checkbox"
                      checked={tasks[key] || false}
                      onChange={() => handleToggle(group.section, item)}
                      className="form-checkbox text-green-500"
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SEOChecklist;
